import axios from '../utils/axios'
import { apis } from "../constants/apis";
import { getStaticConfigs } from "../helpers/common";
import httpService from './httpService';

export async function getListFeedback(payload: any)
{
  return httpService.get(`${apis.feedback.getList}`, {
    params: { ...payload }
  });
}

export async function createFeedback(payload: any)
{
  const staticConfigs = await getStaticConfigs();
  const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;
  return axios.post(`${_url}${apis.feedback.addList}`, payload);
}


export async function updFeedback(payload: any)
{
  return httpService.put(`${apis.feedback.getList}/${payload?.id}/status/${payload?.status}`, { note: payload?.note ?? '' }
  );
}



